<template>
  <div>
    <div class="container">
      <div v-if="isLoading" style="padding-top: 100px;" class="container has-text-centered opaque">
        <i class="fa fa-refresh fa-spin fa-4x"></i>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" class="container">
        <section class="hero one is-dark" style="margin-top: 25px; border-radius: 5px;">
          <div class="hero-body">
            <div class="columns is-vcentered" v-if="!contactSuccess">
              <div class="column is-half">
                <h3 class="title is-6">
                  <strong>If you find this fillable Certificate of Property Insurance form valuable, please reach out to us. We would
                    <u>love</u> to hear from you.</strong>
                </h3>
              </div>
              <div class="column is-half">
                <div class="field is-grouped">
                  <div class="control has-icons-left is-expanded">
                    <input type="email" v-model="contact.email" name="email" class="input is-flat required email" placeholder="email address"
                      required>
                    <span class="icon is-small is-left">
                      <i class="fa fa-envelope"></i>
                    </span>
                  </div>
                  <div class="control">
                    <button class="button is-outlined" :class="{'is-loading': isSendingContactUsEmail}" @click="sendContactMessage(contact)">Reach Out</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns is-vcentered" v-if="contactSuccess">
              <div class="column has-text-centered">
                <h3 class="title is-5">Thank you for your support!</h3>
              </div>
            </div>
          </div>
        </section>
        <section class="section">
          <h3 class="title is-5">Online Fillable Certificate of Property Insurance</h3>
          <hr> While we offer a full featured EOI management system, you can use the following free, online fillable Certificate
          of Property Insurance form to respond to Evidence of Insurance requests as well. Once you complete the form below,
          you can either download a PDF certificate directly or email the certificate.
          <h3 class="title is-6" style="margin-top: 18px;">Guidelines for completing the form</h3>
          <div class="content">
            <ul>
              <li>We recommend to include all insurers and policies, not limited to just property insurance. This can include
                Commercial General Liability, Flood, Employee Theft and Umbrella insurance.
              </li>
              <li>Include a good description of the properties and buildings covered by the insurance in the LOCATION OF PREMISES/DESCRIPTION
                OF PROPERTIES field.
              </li>
              <li>Use the ADDITIONAL REMARKS page to further elaborate about properties and coverage.
              </li>
              <li>For more guidance, have a look at this
                <a href="/static/InsuranceCertificate.pdf" title="Sample Certificate of Property Insurance" alt="Sample Certificate of Property Insurance">Sample Certificate of Property Insurance</a>.
              </li>
            </ul>
          </div>
        </section>
        <div class="field crud-buttons is-grouped is-pulled-right">
          <div class="control">
            <button class="button is-link hide-mobile" @click="openEmailModal()">
              Email (PDF)
              <i style="padding-left: 10px;" class="fa fa-lg fa-envelope-open"></i>
            </button>
            <button class="button is-link hide-desktop" :class="{'is-loading': isGeneratingPdf}" @click="openEmailModal()">
              <i class="fa fa-lg fa-envelope-open"></i>
            </button>
          </div>
          <span>
            <!-- hidden anchor -->
            <a ref="pdf" :download="fileName" :href="pdflink"></a>
            <button class="button is-link hide-mobile" :class="{'is-loading': isGeneratingPdf}" @click="getPdf">
              Download (PDF)
              <i style="padding-left: 10px;" class="fa fa-lg fa-download"></i>
            </button>
            <button class="button is-link hide-desktop" :class="{'is-loading': isGeneratingPdf}" @click="getPdf">
              <i class="fa fa-lg fa-download"></i>
            </button>
          </span>
        </div>
        <div class="section hide-mobile">
          <h3 class="title is-6">Certificate of Property Insurance Form</h3>
          <hr>
        </div>
      </div>
    </div>
    <div v-if="!isLoading" class="container">
      <section class="section">
        <Accord24 :accord24="accord24" :requestViewer="true"></Accord24>
        <Accord24 style="display: none;" ref="accord" :accord24="accord24" :readonly="true"></Accord24>
      </section>
    </div>

    <div class="modal" :class="{'is-active': showEmailModal}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Email Certificate</p>
          <button @click="closeEmailModal()" class="delete"></button>
        </header>
        <div v-if="!emailSuccess">
          <section class="modal-card-body">
            <div class="content">
              <div class="field">
                <label class="label">To</label>
                <div class="control">
                  <input class="input" type="text" v-model="emailData.to" placeholder="Enter a comma separated list of email address">
                  <p v-if="emailInvalidTo" class="help is-danger">
                    Valid email address is required
                  </p>
                </div>
              </div>
              <div class="field">
                <label class="label">CC</label>
                <div class="control">
                  <input class="input" type="text" v-model="emailData.cc" placeholder="Enter a comma separated list of email address">
                  <p v-if="emailInvalidCc" class="help is-danger">
                    Valid email address is required
                  </p>
                  <p class="help">
                    <i class="fa fa-lg fa-paperclip"></i> {{getAttachmentName()}}</p>
                </div>
              </div>
              <div class="field">
                <label class="label">Message</label>
                <div class="control">
                  <textarea class="textarea" v-model="emailData.message" placeholder="Enter message"></textarea>
                </div>
              </div>
            </div>
          </section>
          <section v-if="emailError" class="modal-card-body">
            <hr> Error sending email! Please try again or download PDF and send externally.
            </br>
            </br>
          </section>
          <footer class="modal-card-foot">
            <a class="button is-success" :class="{'is-loading': isSendingEmail}" @click="sendEmailMessage(emailData)">Send</a>
            <a @click="closeEmailModal()" class="button">Cancel</a>
          </footer>
        </div>
        <div v-if="emailSuccess">
          <section class="modal-card-body">
            Thank you, your email has been sent.
            </br>
            </br>
          </section>
          <footer class="modal-card-foot">
            <a @click="closeEmailModal()" class="button">Close</a>
          </footer>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import tenant from '@/tenant'
  import Accord24 from '@/components/associations/Accord24'
  import accordUtil from '@/utilities/accord-util'
  import axios from 'axios'

  export default {
    name: 'RequestViewer',
    data: function () {
      return {
        isLoading: true,
        isSaving: false,
        isGeneratingPdf: false,
        showEmailModal: false,
        emailSuccess: false,
        emailError: false,
        emailInvalidTo: false,
        emailInvalidCc: false,
        isSendingContactUsEmail: false,
        isSendingEmail: false,
        contact: {
          email: ''
        },
        emailData: {
          to: '',
          cc: '',
          message: null
        },
        request: {},
        fileName: '',
        pdflink: '',
        accord24: {}
      }
    },
    created: function () {
      window.scrollTo(0, 0)
      tenant.initialize().then(() => {
        this.initialize(this.$route)
      })
    },
    methods: {
      initialize(route) {
        window.document.title = 'Online Fillable Certificate of Property Insurance'
        this.isLoading = false
      },
      putRequest(request) {
        let key = this.$route.params.id
        this.isSaving = true
        tenant.ref('requests/' + key).set(request).then(() => {
          this.isSaving = false
        })
      },
      getPdf() {
        this.isGeneratingPdf = true

        // go ahead and do a save
        let key = this.$route.params.id
        tenant.ref('requests/' + key).set(this.request)

        let accordForm = this.$refs['accord'].$el.innerHTML
        let rawHTML = this.getAccordDOM(accordForm)
        axios.post(process.env.API_BASE_URL + '/api/certificates/pdf', rawHTML, { responseType: 'arraybuffer' }).then((response) => {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          this.isGeneratingPdf = false
          if (navigator.appVersion.toString().indexOf('.NET') > 0) {
            window.navigator.msSaveBlob(blob, 'InsuranceCertificate.pdf')
          } else {
            this.pdflink = window.URL.createObjectURL(blob)
            this.fileName = 'InsuranceCertificate.pdf'
            this.$nextTick(() => {
              this.$refs['pdf'].click()
            })
          }
        }).catch((error) => {
          this.isGeneratingPdf = false
          console.log(error)
        })
      },
      getAccordDOM(accordForm) {
        return accordUtil.getAccordDOM(accordForm)
      },
      getAttachmentName() {
        return 'Certificate_of_Property_Insurance.pdf'
      },
      openEmailModal() {
        if (!this.emailData.message) {
          this.emailData.message = 'Please see attached Certificate of Insurance.'
          this.showEmailModal = true
        } else {
          this.showEmailModal = true
        }
      },
      closeEmailModal() {
        this.showEmailModal = false
        this.emailSuccess = false
        this.emailError = false
      },
      validateEmailForm(emailData) {
        let foundError = false
        let to = emailData.to
        if (!to || to.indexOf('@') < 1 || to.indexOf('.') < 2) {
          this.emailInvalidTo = true
          foundError = true
        } else {
          this.emailInvalidTo = false
        }

        let cc = emailData.cc
        if (cc && (cc.indexOf('@') < 1 || cc.indexOf('.') < 2)) {
          this.emailInvalidCc = true
          foundError = true
        } else {
          this.emailInvalidCc = false
        }

        if (foundError) {
          return false
        }

        return true
      },
      sendContactMessage(contact) {
        if (!contact.email) {
          this.invalidContactEmail
        }
        this.isSendingContactUsEmail = true
        let message = `New Contact Us request from fillable form \nEmail:  ` + contact.email
        axios.post(process.env.API_BASE_URL + '/api/contact-us', message)
          .then(() => {
            this.contactSuccess = true
            this.isSendingContactUsEmail = false
          }).catch((error) => {
            this.contactSuccess = true
            console.log(error)
          })
      },
      sendEmailMessage(emailData) {
        if (!this.validateEmailForm(emailData)) {
          return
        }
        let accordForm = this.$refs['accord'].$el.innerHTML
        emailData.rawHTML = this.getAccordDOM(accordForm)
        emailData.attachmentName = this.getAttachmentName()
        emailData.subject = 'Certificate of Property Insurance'
        if (emailData.message.indexOf('https://www.getcoi.com') < 0) {
          emailData.message += `



_____________________________

This certificate was provided by GetCOI. We help independent insurance brokers automate certificate of insurance requests.
https://www.getcoi.com
        `
        }

        this.isSendingEmail = true
        axios.post(process.env.API_BASE_URL + '/api/certificates/email-pdf', emailData).then((response) => {
          this.emailSuccess = true
          this.isSendingEmail = false
        }).catch((error) => {
          this.isSendingEmail = false
          this.emailError = true
          console.log(error)
        })
      },
      cancel() {
        this.$router.push('/')
      }
    },
    watch: {
      '$route'() {
        this.initialize(this.$route)
      },
      floatResearch: function () {
        this.researchScroll()
      }
    },
    components: {
      Accord24
    }
  }

</script>

<style scoped>
  .request-title {
    margin-bottom: 20px;
    font-size: 24px;
  }

  .breadcrumb {
    margin-bottom: 0px;
  }

  .section {
    padding-bottom: 0px;
  }

  .one {
    color: white !important;
    background-color: #f5f5f5;
    background-image: -webkit-linear-gradient( 95deg,
    hsl(204, 86%, 53%) 18%,
    hsl(217, 71%, 53%) 18%);
  }
</style>


// WEBPACK FOOTER //
// src/components/request/PublicRequest.vue?558bbdd9